var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsNzDelivery = function SvgNnIconFlagsNzDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nn-icon-flags-NZ-delivery_svg__Lager_39",
    "data-name": "Lager 39",
    viewBox: "0 0 50.47 33.82"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".nn-icon-flags-NZ-delivery_svg__cls-3{fill:#fff}.nn-icon-flags-NZ-delivery_svg__cls-4{fill:#e60026}"))), /*#__PURE__*/React.createElement("path", {
    d: "M.13.13h50.22V33.7H.13z",
    style: {
      fill: "#0037a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 33.34v33.32H25V33.34zm.25-.25H24.77v33.82h50.46V33.09Z",
    style: {
      fill: "#87888a"
    },
    transform: "translate(-24.77 -33.09)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.24 10.06h5v6.86h-5z",
    className: "nn-icon-flags-NZ-delivery_svg__cls-3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.25 16.9h2.73l9.49-6.78-2.74-1.96-9.48 6.79z",
    className: "nn-icon-flags-NZ-delivery_svg__cls-3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m2.07 16.9 8.15-5.82H8.39L.25 16.9z",
    className: "nn-icon-flags-NZ-delivery_svg__cls-4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 16.9h2.73v-1.95l-9.48-6.78-2.73 1.95z",
    className: "nn-icon-flags-NZ-delivery_svg__cls-3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.23 16.9v-1.3l-6.32-4.52h-1.82z",
    className: "nn-icon-flags-NZ-delivery_svg__cls-4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.23.25H22.5l-9.48 6.79 2.73 1.95 9.48-6.78z",
    className: "nn-icon-flags-NZ-delivery_svg__cls-3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m23.41.25-8.14 5.83h1.82L25.23.25z",
    className: "nn-icon-flags-NZ-delivery_svg__cls-4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.98.25H.25V2.2l9.48 6.79 2.73-1.96z",
    className: "nn-icon-flags-NZ-delivery_svg__cls-3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M.25 6.08h10.17v5H.25z",
    className: "nn-icon-flags-NZ-delivery_svg__cls-3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10.24.26h5v6.82h-5z",
    className: "nn-icon-flags-NZ-delivery_svg__cls-3"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M.25.25v1.3l6.32 4.52h1.82z",
    className: "nn-icon-flags-NZ-delivery_svg__cls-4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.05 6.08h10.18v5H15.05z",
    className: "nn-icon-flags-NZ-delivery_svg__cls-3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.24 7.08V.26h-3v6.82H.25v3h10.99v6.83h3v-6.83h10.99v-3z",
    className: "nn-icon-flags-NZ-delivery_svg__cls-4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m38.75 4.22 1.59 4.88-4.15-3.02h5.13L37.17 9.1z",
    className: "nn-icon-flags-NZ-delivery_svg__cls-3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m38.75 5.16 1.03 3.17-2.69-1.96h3.33l-2.69 1.96z",
    className: "nn-icon-flags-NZ-delivery_svg__cls-4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m38.75 23.92 1.76 5.4-4.6-3.34h5.69L37 29.32z",
    className: "nn-icon-flags-NZ-delivery_svg__cls-3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m38.75 24.86 1.2 3.7-3.14-2.29h3.89l-3.15 2.29z",
    className: "nn-icon-flags-NZ-delivery_svg__cls-4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m45.35 10.25 1.42 4.35-3.7-2.69h4.57l-3.7 2.69z",
    className: "nn-icon-flags-NZ-delivery_svg__cls-3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m45.35 11.19.86 2.64-2.24-1.63h2.77l-2.24 1.63z",
    className: "nn-icon-flags-NZ-delivery_svg__cls-4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m31.05 11.96 1.59 4.88-4.15-3.01h5.13l-4.15 3.01z",
    className: "nn-icon-flags-NZ-delivery_svg__cls-3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m31.05 12.91 1.04 3.17-2.7-1.96h3.33l-2.7 1.96z",
    className: "nn-icon-flags-NZ-delivery_svg__cls-4"
  })));
};
export default SvgNnIconFlagsNzDelivery;